/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EscalationRecord } from './EscalationRecord';
import {
    EscalationRecordFromJSON,
    EscalationRecordFromJSONTyped,
    EscalationRecordToJSON,
    EscalationRecordToJSONTyped,
} from './EscalationRecord';

/**
 * 
 * @export
 * @interface WeaknessOwnership
 */
export interface WeaknessOwnership {
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    remediationOwner?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    remediationOwnerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    remediationOwnerType?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    securityTeam?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    securityTeamEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    complianceTeam?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    complianceTeamEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    assignmentSource?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    assignmentRule?: string;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessOwnership
     */
    assignmentLastUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    assignmentLastUpdatedBy?: string;
    /**
     * 
     * @type {Array<EscalationRecord>}
     * @memberof WeaknessOwnership
     */
    escalationHistory?: Array<EscalationRecord>;
    /**
     * 
     * @type {string}
     * @memberof WeaknessOwnership
     */
    delegatedTo?: string;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessOwnership
     */
    delegatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessOwnership
     */
    delegationExpiresAt?: Date;
}

/**
 * Check if a given object implements the WeaknessOwnership interface.
 */
export function instanceOfWeaknessOwnership(value: object): value is WeaknessOwnership {
    return true;
}

export function WeaknessOwnershipFromJSON(json: any): WeaknessOwnership {
    return WeaknessOwnershipFromJSONTyped(json, false);
}

export function WeaknessOwnershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessOwnership {
    if (json == null) {
        return json;
    }
    return {
        
        'remediationOwner': json['remediationOwner'] == null ? undefined : json['remediationOwner'],
        'remediationOwnerEmail': json['remediationOwnerEmail'] == null ? undefined : json['remediationOwnerEmail'],
        'remediationOwnerType': json['remediationOwnerType'] == null ? undefined : json['remediationOwnerType'],
        'securityTeam': json['securityTeam'] == null ? undefined : json['securityTeam'],
        'securityTeamEmail': json['securityTeamEmail'] == null ? undefined : json['securityTeamEmail'],
        'complianceTeam': json['complianceTeam'] == null ? undefined : json['complianceTeam'],
        'complianceTeamEmail': json['complianceTeamEmail'] == null ? undefined : json['complianceTeamEmail'],
        'assignmentSource': json['assignmentSource'] == null ? undefined : json['assignmentSource'],
        'assignmentRule': json['assignmentRule'] == null ? undefined : json['assignmentRule'],
        'assignmentLastUpdated': json['assignmentLastUpdated'] == null ? undefined : (new Date(json['assignmentLastUpdated'])),
        'assignmentLastUpdatedBy': json['assignmentLastUpdatedBy'] == null ? undefined : json['assignmentLastUpdatedBy'],
        'escalationHistory': json['escalationHistory'] == null ? undefined : ((json['escalationHistory'] as Array<any>).map(EscalationRecordFromJSON)),
        'delegatedTo': json['delegatedTo'] == null ? undefined : json['delegatedTo'],
        'delegatedAt': json['delegatedAt'] == null ? undefined : (new Date(json['delegatedAt'])),
        'delegationExpiresAt': json['delegationExpiresAt'] == null ? undefined : (new Date(json['delegationExpiresAt'])),
    };
}

export function WeaknessOwnershipToJSON(json: any): WeaknessOwnership {
    return WeaknessOwnershipToJSONTyped(json, false);
}

export function WeaknessOwnershipToJSONTyped(value?: WeaknessOwnership | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remediationOwner': value['remediationOwner'],
        'remediationOwnerEmail': value['remediationOwnerEmail'],
        'remediationOwnerType': value['remediationOwnerType'],
        'securityTeam': value['securityTeam'],
        'securityTeamEmail': value['securityTeamEmail'],
        'complianceTeam': value['complianceTeam'],
        'complianceTeamEmail': value['complianceTeamEmail'],
        'assignmentSource': value['assignmentSource'],
        'assignmentRule': value['assignmentRule'],
        'assignmentLastUpdated': value['assignmentLastUpdated'] == null ? undefined : ((value['assignmentLastUpdated']).toISOString()),
        'assignmentLastUpdatedBy': value['assignmentLastUpdatedBy'],
        'escalationHistory': value['escalationHistory'] == null ? undefined : ((value['escalationHistory'] as Array<any>).map(EscalationRecordToJSON)),
        'delegatedTo': value['delegatedTo'],
        'delegatedAt': value['delegatedAt'] == null ? undefined : ((value['delegatedAt']).toISOString()),
        'delegationExpiresAt': value['delegationExpiresAt'] == null ? undefined : ((value['delegationExpiresAt']).toISOString()),
    };
}

